import React, { Component } from "react";
import { TextField, Button, CircleProgress } from "reactackle";
import { isMobile } from "react-device-detect";
import RemitRegistration from "./RemitRegistration";
import SendRemittance from "./SendRemittance";
import Iframe from "react-iframe";

class RemitService extends Component {
  state = {
    data: {
      path: "remitService",
      payload: {}
    },
    searchFilters: {
      category: "SEND"
    }
  };

  //single method that work for all fields
  //takes incoming id of the field and then adds field data to state
  stateChangeHandler = (val, id, isPayload) => {
    // console.log(
    //   "val: " + JSON.stringify(val) + " id: " + id + " isPayload: " + isPayload
    // );
    let tmpState = {};
    tmpState[id] = val;

    if (isPayload) {
      this.setState(prevState => {
        if (prevState && prevState.data.payload !== null) {
          return {
            ...prevState,
            data: {
              ...prevState.data,
              payload: {
                ...prevState.data.payload,
                ...tmpState
              }
            }
          };
        } else {
          return {
            ...prevState,
            data: {
              path: prevState.data.path,
              payload: {
                ...tmpState
              }
            }
          };
        }
      });
    } else {
      this.setState(prevState => {
        return {
          ...prevState,
          ...tmpState
        };
      });
    }
  };

  categIsSelected = categName => {
    //console.log(categName + " " + this.state.searchFilters.category);
    let isSelected = false;

    if (this.state.searchFilters.category === categName) {
      isSelected = true;
    }

    return isSelected;
  };

  getCategTabs = () => {
    //console.log(JSON.stringify(this.props.createTable));

    let categList = [
      { name: "SEND", banglaText: "??", icon: "fa fa-flash", color: "blue" },
      {
        name: "STATUS",
        banglaText: "??",
        icon: "fa fa-info-circle",
        color: "oragne"
      },
      { name: "PAYEES", banglaText: "??", icon: "fa fa-heart", color: "red" },
      { name: "REGISTER", banglaText: "??", icon: "fa fa-book", color: "black" }
    ];

    if (categList && categList.length > 0) {
      //console.log("got categ list: " + JSON.stringify(categList));
      return categList.map(item => {
        return (
          <div
            style={{
              height: this.categIsSelected(item.name) ? "37px" : "35px",
              margin: "1px",
              backgroundColor: "white",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minWidth: "24.4%",
              fontSize: "11px",
              textAlign: "center",
              border: this.categIsSelected(item.name)
                ? "1px solid gainsboro"
                : null,
              borderBottom: this.categIsSelected(item.name)
                ? "2px solid grey"
                : "1px solid gainsboro",
              borderTopLeftRadius: "5px",
              borderTopRightRadius: "5px"
            }}
            onClick={() => {
              if (item.name === "ALL") {
                this.stateChangeHandler({}, "searchFilters", false);
              } else {
                this.stateChangeHandler(
                  { category: item.name },
                  "searchFilters",
                  false
                );
              }

              this.props.setScroll(true);
            }}
          >
            <div>
              <div>
                {item.name}
                <span style={{ marginLeft: "3px" }}>
                  <i style={{ color: item.color }} className={item.icon} />
                </span>
              </div>
              <div>{item.banglaText}</div>
            </div>
          </div>
        );
      });
    }
  };

  getRegRecs = () => {
    if (this.props.myRemitRegs && this.props.myRemitRegs.length > 0) {
      return this.props.myRemitRegs.map(reg => {
        return (
          <table className="table table-bordered">
            <tbody>
              <tr>
                <td style={{ backgroundColor: "white" }}>Exchange</td>
                <td style={{ backgroundColor: "white" }}>{reg.exchange}</td>
              </tr>
              <tr>
                <td style={{ backgroundColor: "white" }}>Status</td>
                <td style={{ backgroundColor: "white" }}>{reg.status}</td>
              </tr>
            </tbody>
          </table>
        );
      });
    }
  };

  getRegStatus = () => {
    return (
      <div>
        {this.props.myRemitRegs && this.props.myRemitRegs.length > 0 && (
          <p>
            <br />
            <div>Current Registration Status:</div>
            <div style={{ margin: "10px" }}>{this.getRegRecs()}</div>
          </p>
        )}
        {(!this.props.myRemitRegs ||
          (this.props.myRemitRegs && this.props.myRemitRegs.length === 0)) && (
          <div>
            <div style={{ margin: "10px" }}>
              You don't have an active exchange account
            </div>
            <div style={{ textAlign: "center", padding: "5px" }}>
              <div
                style={{
                  width: "50%",
                  padding: "1px",
                  textAlign: "center",
                  border: "1px solid gainsboro",
                  borderRadius: isMobile ? "5px" : "0px",
                  backgroundColor: "rgb(30, 101, 144)",
                  margin: "auto",
                  padding: "6px",
                  fontWeight: "bold",
                  color: "white",
                  fontSize: "12px",
                  minWidth: "140px"
                }}
                onClick={() => {
                  this.stateChangeHandler(
                    { category: "REGISTER" },
                    "searchFilters",
                    false
                  );
                }}
              >
                <div>TAP HERE TO REGISTER</div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  regCheck = () => {
    let regStatus = false;
    if (this.props.myRemitRegs && this.props.myRemitRegs.length > 0) {
      for (let i = 0; i < this.props.myRemitRegs.length; i++) {
        if (
          this.props.myRemitRegs[i].status &&
          this.props.myRemitRegs[i].status === "ACTIVE"
        ) {
          regStatus = true;
        }
      }
    }
    return regStatus;
  };

  getNewRemittance = () => {
    return (
      <div>
        <div>Prime Test</div>

        <div>{!this.regCheck() && this.getRegStatus()}</div>
        {this.regCheck() && (
          <SendRemittance
            myRemitRegs={this.props.myRemitRegs}
            onReachApi={this.props.onReachApi}
            firebase={this.props.firebase}
            agraniRates={this.props.agraniRates}
            primeRates={this.props.primeRates}
            onAddRecord={this.props.onAddRecord}
            myRemitApplication={this.props.myRemitApplication}
            setScroll={this.props.setScroll}
            cellPhone={this.props.cellPhone}
          />
        )}
      </div>
    );
  };

  getViewHistory = () => {
    return <div>Old Applications</div>;
  };

  getRegistration = () => {
    return (
      <RemitRegistration
        firebase={this.props.firebase}
        myRemitRegs={this.props.myRemitRegs}
        onSendEmail={this.props.onSendEmail}
        onNotifyUsers={this.props.onNotifyUsers}
        cellPhone={this.props.cellPhone}
        setScroll={this.props.setScroll}
        regCheck={this.regCheck()}
      />
    );
  };

  getPayees = () => {
    return <div>Payees</div>;
  };

  getRegFormField = (fieldId, placeholder, caption) => {
    return (
      <div>
        <div
          style={{
            padding: "1px",
            textAlign: "right",
            border: "1px solid gainsboro",
            borderRadius: isMobile ? "5px" : "0px",
            backgroundColor: "white",
            zIndex: "-9",
            margin: "5px",
            fontSize: "12px"
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row"
            }}
          >
            <div
              style={{
                width: "40%",
                lineHeight: "12px",
                textAlign: "left",
                paddingLeft: "5px",
                margin: "auto"
              }}
            >
              {caption}
            </div>
            <div
              style={{
                width: "60%",
                border: "1px solid gainsboro",
                borderRadius: "5px",
                borderTopLeftRadius: "0px",
                borderBottomLeftRadius: "0px",
                margin: "2px"
              }}
            >
              <TextField
                value={this.state.data.payload[fieldId]}
                onChange={e => {
                  this.stateChangeHandler(e.value, fieldId, true);
                  if (fieldId === "textNameBangla") {
                    this.getBanglaImage(e.value);
                  }
                }}
                onFocus={() => {
                  this.stateChangeHandler(fieldId, "selectedField", false);
                }}
                onFocusOut={() => {
                  console.log("focus out");
                }}
                fullWidth
                placeholder={placeholder}
              />
            </div>
          </div>
        </div>
        {this.state.selectedField &&
          this.state.selectedField === fieldId &&
          this.state.availableOptions && (
            <div
              style={{
                padding: "5px",
                overflow: "auto",
                border: "1.5px solid white"
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  borderBottom: "1.5px soid white",
                  margin: "-5px",
                  marginBottom: "5px"
                }}
              >
                <div
                  style={{
                    width: "70%",
                    borderBottom: "1.5px solid white",
                    paddingLeft: "5px",
                    textAlign: "left"
                  }}
                >
                  Suggestions:
                </div>
                <div
                  style={{
                    width: "30%",
                    textAlign: "right",
                    borderBottom: "1.5px solid white",
                    paddingRight: "5px"
                  }}
                  onClick={() => {
                    this.stateChangeHandler(undefined, "selectedField", false);
                  }}
                >
                  <icon
                    className="fa fa-close"
                    style={{ color: "red", fontSize: "20px" }}
                  />
                </div>
              </div>
              {this.getSelectionTexts(fieldId)}
            </div>
          )}
      </div>
    );
  };

  render() {
    return (
      <div>
        {this.props.regsReady && (
          <div
            style={{
              padding: "0px"
            }}
          >
            <div
              style={{
                margin: "0px",
                zIndex: "5",
                width: "100%",
                display: "flex",
                alignItems: "flex-end",
                padding: "2px",
                flexDirection: "row",
                maxWidth: "600px"
              }}
            >
              {this.getCategTabs()}
            </div>
            {this.state.searchFilters.category === "SEND" && (
              <div
                style={{
                  backgroundColor: "white",
                  padding: "5px",
                  marginLeft: "4px",
                  marginRight: "4px"
                }}
              >
                {this.getNewRemittance()}
              </div>
            )}
            {this.state.searchFilters.category === "STATUS" && (
              <div
                style={{
                  backgroundColor: "white",
                  padding: "5px"
                }}
              >
                {this.getViewHistory()}
              </div>
            )}
            {this.state.searchFilters.category === "REGISTER" && (
              <div
                style={{
                  backgroundColor: "white",
                  padding: "5px",
                  marginLeft: "3px",
                  marginRight: "3px"
                }}
              >
                {this.getRegistration()}
              </div>
            )}
            {this.state.searchFilters.category === "PAYEES" && (
              <div
                style={{
                  backgroundColor: "white",
                  padding: "5px"
                }}
              >
                {this.getPayees()}
              </div>
            )}
          </div>
        )}
        {!this.props.regsReady && <div>Connecting...</div>}
      </div>
    );
  }
}

export default RemitService;



// WEBPACK FOOTER //
// ./src/app/components/Screens/landingPage/RemitService.jsx